import React from 'react';
import { useSelector } from 'react-redux';
import { UserPreferenceSelector } from '@store/selectors/UserProfileSelector';
import { useCollectionEntity } from '@utilities/hooks/useCollectionEntity/useCollectionEntity';
import { ENDPOINT_USER_UNITS } from '@utilities/apiConstants';
import { Unit } from '@data/unit/Unit';

const MANAGE_ACCESS_TYPE = 'manage';
export const useGetAccessesList = (unitId: string) => {
	const { practices } = useSelector(UserPreferenceSelector);
	const { ministry } = useCollectionEntity<Unit>(ENDPOINT_USER_UNITS, unitId, 'id');
	const applicationId = window.config.ASCENSION_ID_APPLICATION_ID;

	return React.useMemo(() => ministry && practices && practices.length ?
		[
			...practices.map((practice) => ({
				property: MANAGE_ACCESS_TYPE,
				value: `azp::${applicationId}&locationId::${practice.euid}`,
			})),
			{
				property: MANAGE_ACCESS_TYPE,
				value: `azp::${applicationId}&user_roles:>CT-ORSCHEDULER&windowsaccountname:>${ministry}`,
			},
			{
				property: MANAGE_ACCESS_TYPE,
				value: `azp::${applicationId}&user_roles:>CT-HOSPITALVIEWER&windowsaccountname:>${ministry}`,
			}
		] : undefined
	, [applicationId, ministry, practices]);
};
